import VueRouter from "vue-router"

import NotFound from "@/pages/not-found.vue"
import Login from "@/pages/login.vue"
import Layout from "@/pages/layout.vue"
import Home from "@/pages/home/index.vue"
import Profile from "@/pages/profile.vue"
import UseTerms from "@/pages/use-terms.vue"

import routers from "@/pages/routers"
import store from  "@/store"
import AppLocalStorage from "@/services/app-local-storage"

const catchNotFound = { path: "*", redirect: "/notfound" }
const notFoundRoute = { path: "/notfound", component: NotFound }
const loginRoute = { path: "/login", component: Login }

let layoutChildRoutes = [
  { path: "", component: Home },
  { path: "/profile", component: Profile },
  { path: "/use-terms", component: UseTerms },
]

routers.forEach((router) => router.addRoutes(layoutChildRoutes))

const layoutRoutes = { path: "", component: Layout, children: layoutChildRoutes }

const router = new VueRouter({
  routes: [
    loginRoute,
    layoutRoutes,
    notFoundRoute,
    catchNotFound,
  ],
  mode: "history"
})

router.beforeEach((to, from, next) => {

  const loginPath = "/login"
  const useTermsPath = "/use-terms"

  if (to.path === loginPath) {
    next()
    return
  }

  let user = store.state.user

  if (!user) {
    let appStore = AppLocalStorage.checkStore()
    user = appStore.state.user
  }
  
  if (!user) {
    next(loginPath)
    return
  }

  if (to.path !== useTermsPath && !user.useTerms) {
    next(useTermsPath)
    return
  }

  next()
})

router.afterEach((to, from) => {

  $("body,html").animate({
    scrollTop: 0
  }, 300)
})

export default router
